// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3pldn","errors":"Errors_errors__3EpBl"};